import { useAppSelector } from 'hooks';
import { AccessRoles } from 'constants/enums';
import { getCurrentGroup } from 'store/groups/selectors';

/**
 * roles are logical OR: any role is sufficient to grant access to a page
 */
const useRole = (roles: AccessRoles[]) => {
  const aid = useAppSelector((state) => state.oauth.data?.aid);
  const groups = useAppSelector((state) => state.groups.groupInfo.data);
  const userRole = useAppSelector((state) => parseInt(state.oauth.data?.role || '0'));
  const groupAdmins = useAppSelector(({ groups }) => groups.groupAdmins.data);
  const currentGroup = useAppSelector(getCurrentGroup);

  // Sysop is a system-level role — check oauth directly, not groupAdmins
  if (roles.includes(AccessRoles.SYSOP) && userRole === AccessRoles.SYSOP) {
    return true;
  }

  const checkAllGroupsForRole = (_role: AccessRoles) => {
    for (const group of groups) {
      if (group.gid !== 'all' && !checkGroupForRole(group.gid, _role)) {
        return false;
      }
    }
    return true;
  };

  const checkGroupForRole = (_gid: string, _role: AccessRoles) => {
    if (_gid === 'all') {
      return checkAllGroupsForRole(_role);
    }
    return groupAdmins.some(
      (admin) =>
        admin.aid === aid &&
        admin.roles.some((role) => role.gid === _gid && role.roles.includes(_role))
    );
  };

  let hasRole = false;
  for (const role of roles) {
    if (checkGroupForRole(currentGroup?.gid || '', role)) {
      hasRole = true;
      break;
    }
  }
  return hasRole;
};

export default useRole;
